import { TreeNode } from 'primeng/api';

export class ObjectNode implements TreeNode {
	label?: string;
	type?: string;
	data?: any;
	parent?: ObjectNode;
	children?: ObjectNode[];
	expanded?: boolean;

	formatter: (object: any) => string;

	constructor(object: any, formatter: (object: any) => string, children?: ObjectNode[]) {
		this.data = object;
		this.formatter = formatter;
		this.label = this.formatter(this.data);
		if (children) {
			this.children = children ? this.children : [];
		}
	}

	addChild(child: ObjectNode) {
		if (!this.children) {
			this.children = [];
		}
		this.children.push(child);
	}

	isLeaf(): boolean {
		return !this.children || this.children.length === 0;
	}
}
